/** @jsx jsx */
import { css, jsx, SerializedStyles } from '@emotion/core';
import { SvgIcon, SvgIconProps } from '@material-ui/core';

import { ICustomTheme } from 'interfaces';

type colorType = 'primary' | 'secondary';

const getCssIconPath =
  (color?: colorType) =>
  (theme: ICustomTheme): SerializedStyles =>
    css({
      fill: color === 'primary' ? theme.colors.white : theme.colors.grey.light,
    });

interface IExportIcon extends SvgIconProps {
  color?: colorType;
}

export default function ExportIcon({
  color = 'primary',
  ...props
}: IExportIcon) {
  return (
    <SvgIcon width="16.5" height="16.732" viewBox="0 0 16.5 16.732" {...props}>
      <g data-name="Groupe 777">
        <path
          data-name="Tracé 323"
          d="M226.75 278.052h-4.659a.75.75 0 0 0 0 1.5h2.982l-6.7 6.787a.75.75 0 1 0 1.067 1.054l6.56-6.646v2.674a.75.75 0 0 0 1.5 0V278.8a.75.75 0 0 0-.75-.748z"
          transform="translate(-211 -278.052)"
          css={getCssIconPath(color)}
        />
        <path
          data-name="Tracé 324"
          d="M224.9 286.448a.75.75 0 0 0-.75.75v6.086H212.5v-11.661h6.079a.75.75 0 1 0 0-1.5h-6.829a.75.75 0 0 0-.75.75v13.161a.75.75 0 0 0 .75.75h13.15a.75.75 0 0 0 .75-.75V287.2a.75.75 0 0 0-.75-.752z"
          transform="translate(-211 -278.052)"
          css={getCssIconPath(color)}
        />
      </g>
    </SvgIcon>
  );
}
